import { useContext } from 'react';
import { PlayersContext } from '@playerContext/PlayersContext';

const usePlayersContext = () => {
    const context = useContext(PlayersContext);

    if (!context) {
        throw new Error(
            'useEpisodePlayersContext must be used within a component that is wrapped by AppProviderPlayer'
        );
    }

    return context;
};

export default usePlayersContext;
